export default __webpack_public_path__ + "static/media/holiday-journeys.3195a438.svg";